module.exports = __webpack_public_path__ + "static/media/23_B.9c2d39f6.png";